import { HttpStatusCode } from './statusCodes';

export class FetchError extends Error {
  readonly statusCode: number;
  readonly responseBody?: unknown;

  constructor(message: string, response: Response, responseBody?: unknown, options?: ErrorOptions) {
    super(message, options);
    this.statusCode = response.status;
    this.responseBody = responseBody;
  }
}

export const getIsFetchNotFoundError = (error: unknown): boolean => {
  return error instanceof FetchError && error.statusCode === HttpStatusCode.NotFound;
};

export const SEARCH_DEPTH_LIMIT_ERROR_MESSAGE = 'Invalid query: maximum offset + limit for search query';

export const getIsSearchDepthLimitError = (error: unknown): boolean => {
  if (!(error instanceof FetchError)) return false;
  if (error.statusCode !== HttpStatusCode.BadRequest) return false;

  const body = error.responseBody;
  if (Array.isArray(body)) {
    const lowerCaseSearchString = SEARCH_DEPTH_LIMIT_ERROR_MESSAGE.toLowerCase();
    return body.some(msg => typeof msg === 'string' && msg.toLowerCase().includes(lowerCaseSearchString));
  }
  return false;
};
